module.exports = "<div class=\"page-spinner-container\" [class.hide]=\"!isShown\">\r\n    <div class=\"spinner page-loader\">\r\n        <div class=\"rect1\"></div>\r\n        <div class=\"rect2\"></div>\r\n        <div class=\"rect3\"></div>\r\n        <div class=\"rect4\"></div>\r\n        <div class=\"rect5\"></div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/loader/loader.component.html
// module id = 554
// module chunks = 1